import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Button,
} from "@mui/material";

const backdrop = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const modal = {
  hidden: { y: "-50vh", opacity: 0 },
  visible: {
    y: "0",
    opacity: 1,
    transition: { delay: 0.2 },
  },
};

const PaymentOptionModal = ({
  open,
  onClose,
  onConfirm,
  paymentMethod,
  setPaymentMethod,
  showgateway,
}) => {
  const handleConfirm = () => {
    onConfirm(paymentMethod);
    onClose();
  };

  return (
    <motion.div
      variants={backdrop}
      initial="hidden"
      animate={open ? "visible" : "hidden"}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        // backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 1300,
        display: open ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <motion.div variants={modal}>
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>Select Payment Method</DialogTitle>
          <DialogContent>
            <FormControl>
              <RadioGroup
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
              >
                <FormControlLabel
                  value="cod"
                  control={<Radio />}
                  label="Cash on Delivery"
                />
                {showgateway ? (
                  <>
                    {" "}
                    <FormControlLabel
                      value="online"
                      control={<Radio />}
                      label="Online Payment"
                    />
                  </>
                ) : (
                  <></>
                )}
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button variant="contained" onClick={handleConfirm}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </motion.div>
    </motion.div>
  );
};

export default PaymentOptionModal;
